import { render, staticRenderFns } from "./PrintReceipt.vue?vue&type=template&id=8b11b2e4&"
import script from "./PrintReceipt.vue?vue&type=script&lang=ts&"
export * from "./PrintReceipt.vue?vue&type=script&lang=ts&"
import style0 from "./PrintReceipt.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports